// extracted by mini-css-extract-plugin
export default {"container":"CustomModal_container__c621v","mainContainer":"CustomModal_mainContainer__xbcz+"};